<div>
  <nz-layout [class.ant-layout-has-sider]="!isHorizontal">
    <ng-container [ngTemplateOutlet]="isHorizontal ? menuHorTpl : menuVerTpl"></ng-container>
   <nz-content>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
   </nz-content>
  </nz-layout>
</div>
<ng-template #menuHorTpl>
  <nz-header class="shadow-sm bg-white">
    <div class="d-flex justify-content-between vss-ui-menu-header">
      <div class="logo" style="text-align: center;">
        <img [src]="logoUrl" alt="">
      </div>
      <div class="d-flex vss-ui-nav-menu">
        <ng-container *ngTemplateOutlet="extendStartTpl"></ng-container>
        <ng-container [ngTemplateOutlet]="menuTpl"></ng-container>
        <ng-container *ngTemplateOutlet="extendEndTpl"></ng-container>
        <div class="notify bg-transparent" nz-popover [nzPopoverContent]="popoverInfoUserTpl || InfoUser" nzPopoverTrigger="click"
             nzPopoverPlacement="rightBottom" [(nzPopoverVisible)]="nzPopoverUserVisible">
          <vss-ui-avatar-text *ngIf="currentUser?.fullName || currentUser?.userName"
                              [textAvatar]="currentUser?.fullName || currentUser?.userName || 'A'"
                              [sizeAvatar]="32" [numberOfChar]="2"></vss-ui-avatar-text>
          <nz-avatar *ngIf="!currentUser?.fullName && !currentUser?.userName" nzIcon="user" nzSrc=""></nz-avatar>
        </div>
      </div>
    </div>
  </nz-header>
</ng-template>
<ng-template #menuVerTpl>
  <nz-sider [nzWidth]="280" nzCollapsible
            [(nzCollapsed)]="isCollapsed" [nzTrigger]="null" class="shadow-sm bg-white  "
            [class]="isCollapsed ? 'menu-sidebar-fix' : 'menu-sidebar'">
    <div class="h-100 d-flex  justify-content-between flex-column vss-ui-menu-slider">
      <div>
        <div class="logo" style="text-align: center;">
          <img [src]="logoUrl" alt="">
        </div>
        <hr class="w-75 m-auto mb-1" *ngIf="isCollapsed">
        <ng-container *ngTemplateOutlet="extendStartTpl"></ng-container>
        <ng-container [ngTemplateOutlet]="menuTpl" [ngTemplateOutletContext]="{collapsed: isCollapsed}"></ng-container>
      </div>
      <div class="cuz-collaps">
        <ng-container *ngTemplateOutlet="extendEndTpl"></ng-container>
        <div class="notify bg-transparent" nz-popover [nzPopoverContent]="popoverInfoUserTpl || InfoUser" nzPopoverTrigger="click"
             nzPopoverPlacement="rightBottom" [(nzPopoverVisible)]="nzPopoverUserVisible">
          <vss-ui-avatar-text *ngIf="currentUser?.fullName || currentUser?.userName"
                              [textAvatar]="currentUser?.shortName || currentUser?.fullName || currentUser?.fullName || currentUser?.userName || 'A'"
                              [sizeAvatar]="sizeAvatar" [numberOfChar]="numberOfAvatar"></vss-ui-avatar-text>
          <nz-avatar *ngIf="!currentUser?.fullName && !currentUser?.userName" nzIcon="user" nzSrc=""></nz-avatar>
        </div>
        <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
           (click)="changeExpand()" aria-hidden="true"></i>
      </div>
    </div>
  </nz-sider>
</ng-template>
<ng-template #menuTpl let-collapsed="collapsed">
  <div class="wrapper cs-menu">
    <ul nz-menu nzTheme="light" class="h-100" [nzMode]="isHorizontal? 'horizontal':'inline'"
        [nzInlineCollapsed]="collapsed">
      <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: listMenus }"></ng-container>
      <ng-template #menuTpl let-menus>
        <ng-container *ngFor="let menu of menus">
          <ng-container *ruleAuthorized="menu.roles || []">
            <li *ngIf="!menu.children.length && !menu?.isHide" nz-menu-item [nzDisabled]="menu.disabled" (click)="clickItem(menu)"
                [nz-tooltip]="collapsed ? menu.title || '' : ''" nzTooltipPlacement="right"
                [nzSelected]="currentPage?.id === menu.id ">
              <ng-container [ngTemplateOutlet]="titleMenu"></ng-container>
            </li>
            <li *ngIf="menu.children.length && !menu?.isHide" nz-submenu
                [class.active-sub-menu]="currentPage?.parent === menu.id"
                [nzTitle]="titleMenu"
                [nzDisabled]="menu.disabled">
              <ul class="w-100">
                <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }"></ng-container>
              </ul>
            </li>
            <ng-template #titleMenu>
              <ng-container *ngIf="!isHorizontal">
                <i nz-icon style="margin-right: 5px; font-size: 1rem;" class="fa cs-icon-menu"
                   [ngClass]="menu.icon" *ngIf="menu.icon && !menu.htmlIcon" aria-hidden="true"></i>
                <span *ngIf="menu.htmlIcon" [innerHTML]="menu.htmlIcon | vssSafeHtml" class="vss-ui-menu-html-icon"></span>
              </ng-container>
              <span>{{ menu.title }}</span>
            </ng-template>
          </ng-container>
        </ng-container>
      </ng-template>
    </ul>
  </div>
</ng-template>

<ng-template #InfoUser>
  <div class="info-user">
    <div class="title">
      <span>Thông tin tài khoản</span>
      <div>
        <a (click)="nzPopoverUserVisible = false">
          <i nz-icon nzType="close" aria-hidden="true"></i>
        </a>
      </div>
    </div>
    <div class="border-bottom text-center">
      <div class="bg-image">
        <div class="avatar">
          <vss-ui-upload-image [urlImage]="currentUser?.image"></vss-ui-upload-image>
        </div>
      </div>

      <div class="text-center pt-5">
        <h5 class="mt-3">{{currentUser?.fullName}}</h5>
        <p class="text-info-user" *ngIf="currentUser?.email">{{currentUser?.userName}} - {{currentUser?.email}}</p>
        <p class="text-info-user" *ngIf="!currentUser?.email">{{currentUser?.userName}}</p>
      </div>
    </div>
    <div class="row p-4 info">
      <div class="col-4 text-info-user">
        <p>Phòng ban</p>
      </div>
      <div class="col-8">
        <p>{{currentUser?.departmentName || '-'}}</p>
      </div>
      <div class="col-4 text-info-user">
        <p>Siêu thị</p>
      </div>
      <div class="col-8">
        <p>{{currentUser?.storeName || '-'}}</p>
      </div>
      <div class="col-4 text-info-user">
        <p>Chức vụ</p>
      </div>
      <div class="col-8">
        <p>{{currentUser?.positionName || '-'}}</p>
      </div>
      <div class="col-4 text-info-user">
        <p>Vị trí kiêm nhiệm</p>
      </div>
      <div class="col-8">
        <p>{{currentUser?.workingPositionName || '-'}}</p>
      </div>
      <div class="col-4 text-info-user">
        <p>Giới tính</p>
      </div>
      <div class="col-8">
        <p>{{currentUser?.gender ? 'Nam' : 'Nữ'}}</p>
      </div>
    </div>
    <div class="text-center p-4 pt-0">
      <button nz-button nzType="primary" (click)="logout()" nzGhost type="button" class="btn-logout"> Đăng
        xuất</button>
    </div>
  </div>
</ng-template>
